import React from 'react';
import cn from "classnames";
import style from "../pagination.module.scss"

const DefaultPaginationWrapper = ({ children }) => {
  return (
    <div className={style.wrapper}>
        { children }
    </div>
  );
};

export default DefaultPaginationWrapper;